import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import waste from '../../json/general-waste-disposal-data.json'

const wasteServiceData = {
  name: 'General Waste Disposal and Recycling Services',
  description:
    'Nationwide general waste and recycling collection for businesses and households. Dimension handles bagged trash, bins of mixed recyclables, cardboard, and overflow on one-time or recurring schedules with a waste diversion report.',
  serviceType: 'Waste Disposal',
  url: 'https://getdimension.com/general-waste-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Commercial Waste Collection' },
    { name: 'Mixed Recycling Collection' },
    { name: 'Recurring Trash and Recycling Pickup' },
    { name: 'Overflow and One-Time Waste Removal' },
  ],
}

const wasteFAQData = {
  questions: waste.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function GeneralWasteDisposal() {
  return (
    <>
      <Head>
        <title>Waste Disposal and Recycling Services | Dimension</title>
        <meta
          name="description"
          content="Reliable waste disposal and recycling for businesses and homes nationwide. Bag, bin, and cubic-yard pricing from around $79, one-time or recurring, with a diversion report."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/general-waste-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={wasteServiceData} />
        <SchemaMarkup type="FAQPage" data={wasteFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={waste.pitch.heading}
          material={waste.pitch.material}
          pitchText={waste.pitch.pitchText}
          ctaLink={waste.pitch.ctaLink}
          ctaText={waste.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...waste.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...waste.benefits} />
        <CaseStudy {...waste.caseStudy} />
        <Approach {...waste.approach} />
        <FAQ {...waste.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Junk Removal Services',
              href: '/junk-removal',
              description:
                'Bulky residential and commercial cleanouts — furniture, mattresses, appliances, and electronics.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'Roll-off containers from 5 to 40 yards when volume outgrows bins and bags.',
            },
            {
              label: 'Commercial Waste Disposal',
              href: '/commercial-waste-disposal',
              description:
                'Account structure, sector coverage, and volume pricing for businesses with one site or fifty.',
            },
            {
              label: 'Hazardous Waste Disposal',
              href: '/other-hazardous-waste',
              description:
                'Compliant handling for paint, solvents, oil, chemicals, and batteries that general waste cannot take.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default GeneralWasteDisposal
